import React, { useState } from 'react';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Row } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

import { style } from 'typestyle';

import contactUs from '../../global/lib/contactUs';
import { PageState } from './app';

const submitButton = style({ marginTop: '1em', marginBottom: '3em'});

const requiredField = style({
    $nest: {
        '&::after' : {
            content: '"*"',
            color: '#8a6d3b'
        }
    }
});

const header = style({
    marginTop: 82
});

interface ContactUsFormProps {
    updateState: (pageState: PageState) => void;
}

const ContactUsForm: React.FC<ContactUsFormProps> = (props) => {

    const [name, setName] = useState<{value: string | null, valid: 'success' | 'warning' | 'error' | null}>({value: null, valid: null});
    const [email, setEmail] = useState<{value: string | null, valid: 'success' | 'warning' | 'error' | null}>({value: null, valid: null});
    const [phone, setPhone] = useState<{value: string}>({value: null});
    const [organization, setOrganization] = useState<{value: string}>({value: null});
    const [message, setMessage] = useState<{value: string}>({value: null});
    const [reCaptcha, setReCaptcha] = useState<{value: string}>({value: null});
    const [submitted, setSubmitted] = useState(false); // NOT REALLY USING THIS PROBALY SHOULD REMOVE

    const validName = (name: string) => name.length > 0;

    const validEmail = (email) => {
        const emailExpr = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return emailExpr.test(email);
    };;    

    const handleUpdate = (input: 'name' | 'email' | 'phone' | 'organization' | 'message', evt) => {

        let value = evt.target.value;

        switch (input) {
            case 'name': validName(value) ? setName({value, valid: 'success'}) : setName({value, valid: 'error'}); break;
            case 'email': validEmail(value) ? setEmail({value, valid: 'success'}) : setEmail({value, valid: 'error'}); break;
            case 'phone': setPhone({value}); break;
            case 'organization': setOrganization({value}); break;
            case 'message': setMessage({value}); break;
        }
    };

    const handleCaptach = (value) => {
        setReCaptcha({ value })
    };
    
    const submitRequest = () => {

        let inValidForm = false;

        setSubmitted(true);

        if (!validName(name.value) ) {
            setName({...name, valid: 'error'});
            inValidForm = true;
        }

        if (!validEmail(email.value) ) {
            setEmail({...name, valid: 'error'});
            inValidForm = true;
        }        

        if (inValidForm) { return; }

        const data = {
            fullName: name.value,
            email: email.value,
            phone: phone.value,
            company: organization.value,
            message: message.value,
            reCaptcha: reCaptcha.value
        };

        contactUs(data).
            then( res => props.updateState(PageState.success)).
            catch( () =>  props.updateState(PageState.error));
    }    

    return <div className={header}>
        <Form horizontal >

            <h2 aria-label='Name of the form ??'>Get In Touch</h2>

            <Row>
                <Col lg={6}>
                    <FormGroup controlId='formValidationWarning2' validationState={ name.valid } >
                        <Col componentClass={ControlLabel} lg={2} className={requiredField}>Name</Col>
                        <Col lg={10}>
                            <FormControl
                                value={ name.value }
                                onChange={handleUpdate.bind({}, 'name')} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col componentClass={ControlLabel} lg={2}>Phone</Col>
                        <Col lg={10}>
                            <FormControl
                                value={ phone.value }
                                onChange={handleUpdate.bind({}, 'phone')} />
                        </Col>
                    </FormGroup>
                </Col>

                <Col lg={6}>
                    <FormGroup controlId='formValidationWarning3' validationState={ email.valid }>
                        <Col componentClass={ControlLabel} lg={2} className={requiredField}>Email</Col>
                        <Col lg={10}>
                            <FormControl
                                value={ email.value }
                                onChange={handleUpdate.bind({}, 'email')} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col componentClass={ControlLabel} lg={2}>Company</Col>
                        <Col lg={10}>
                            <FormControl
                                value={ organization.value }
                                onChange={handleUpdate.bind({}, 'organization')} />
                        </Col>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col lg={12}>
                    <FormGroup>
                        <Col componentClass={ControlLabel} lg={1}>Message</Col>
                        <Col lg={11}>
                            <textarea
                                value={ message.value }
                                onChange={handleUpdate.bind(this, 'message')}
                                className={'form-control'}
                                rows={8} ></textarea>
                        </Col>
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col componentClass={ControlLabel} lg={1}></Col>
                <Col lg={11} >
                    <ReCAPTCHA
                        sitekey='6LejiSgTAAAAAAbtbtNFMkKayp4Z6cc9dmGdkCvt'
                        onChange={ handleCaptach.bind({}) } />
                </Col>
            </Row>

            <Row>
                <Col componentClass={ControlLabel} lg={1}></Col>
                <Col lg={11}>
                    <Button
                        onClick={ submitRequest.bind({}) }
                        bsStyle='primary'
                        bsSize='large'
                        disabled={!reCaptcha.value}
                        className={submitButton} >Submit</Button>
                </Col>
            </Row>

        </Form>
    </div>;
};

export default ContactUsForm;